import { CatchmentDTOFactory } from './CatchmentDTOFactory'
import { TimeStepMaxDTO } from './TimeStepMaxDTO'
import { TimeStepMaxRaw } from './TimeStepMaxRaw'

export class TimeStepMaxDTOFactory {
  static fromRaw(raw: TimeStepMaxRaw): TimeStepMaxDTO {
    const administrativeAreas = raw.area_floods
    const catchments = raw.catchment_floods
    return new TimeStepMaxDTO(
      administrativeAreas,
      catchments.map((c) => CatchmentDTOFactory.fromRaw(c)),
    )
  }
}
